import {
  DeprecatedDropdown,
  DeprecatedDropdownButton,
  DeprecatedDropdownItem,
  DeprecatedDropdownMenu,
} from "@deere/fuel-react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

interface PartsPromotionsMenuProps {
  selected: boolean;
  showPartInfo?: boolean;
  showPromotion?: boolean;
}

const PartsPromotionsMenu = ({
  selected,
  showPartInfo,
  showPromotion,
}: PartsPromotionsMenuProps) => {
  const { t } = useTranslation("common");
  const theme = useTheme();

  const partsUrl = "/parts";
  const promotionsUrl = "/promotions";

  const dropDownItemStyle = {
    borderWidth: "0 0 0 3px",
    borderStyle: "solid",
    borderColor: "transparent",
    cursor: "pointer",
  } as const;

  const dropDownHoverStyle = {
    ".MenuItem-link:hover": {
      color: theme.tokens.FuelColorBrandPrimary,
      backgroundColor: theme.tokens.FuelColorAlertSuccessBackground,
      borderColor: `${theme.tokens.FuelColorAlertSuccessBorder} !important`,
    },
  };

  return (
    <DeprecatedDropdown>
      <DeprecatedDropdownButton
        variant="text"
        selected={selected}
        data-testid="parts-promotions-dropdown"
        style={{
          padding: "20px 8px",
          color: theme.tokens.FuelColorGray600,
          borderRadius: "0px",
          ...(selected && {
            color: theme.tokens.FuelColorBrandPrimary,
            fontWeight: theme.tokens.FuelFontWeightSemibold,
            borderBottom: `3px solid ${theme.tokens.FuelColorBrandPrimary}`,
          }),
        }}
      >
        {t("header.navItem.partsPromotions")}
      </DeprecatedDropdownButton>
      <DeprecatedDropdownMenu
        className="parts-promotions-menu-dropdown"
        style={{ minWidth: "max-content" }}
      >
        <Box sx={dropDownHoverStyle}>
          <Link
            to={partsUrl}
            style={{ textDecoration: "none" }}
            hidden={!showPartInfo}
          >
            <DeprecatedDropdownItem
              style={dropDownItemStyle}
              data-testid="parts-promotions-dropdownitem-parts"
            >
              {t("header.navItem.parts")}
            </DeprecatedDropdownItem>
          </Link>
          <Link
            to={promotionsUrl}
            style={{ textDecoration: "none" }}
            hidden={!showPromotion}
          >
            <DeprecatedDropdownItem
              style={dropDownItemStyle}
              data-testid="parts-promotions-dropdownitem-promotions"
            >
              {t("header.navItem.promotions")}
            </DeprecatedDropdownItem>
          </Link>
        </Box>
      </DeprecatedDropdownMenu>
    </DeprecatedDropdown>
  );
};

export default PartsPromotionsMenu;
